import {Injectable} from '@angular/core';
import {Constants} from '../constants/constants';
import {PermissionManagerService} from './permission-manager.service';
import {Controles} from '../constants/controles';

@Injectable({
  providedIn: 'root'
})
export class TablaValidacionesService {
  Control = Controles;

  constructor(public constants: Constants,
              private permissionManagerService: PermissionManagerService) {
  }


  setStyleColumn(tabla: string, dataSource: any, column?: any): string {
    switch (tabla) {
      case this.constants.PSPERSON:
      case this.constants.PSPERSON_PROPIETARIO:
        if (dataSource.activo === false) {
          return 'alert-yellow';
        }
        return '';
        break;
      case this.constants.INPATRIM:
        if (dataSource.estatus === false) {
          return 'alert-danger';
        }
        return '';
        break;
      case this.constants.PSCONTAC:
        if (dataSource.activo === false) {
          return 'alert-yellow';
        }
        return '';
        break;
      case this.constants.PSCLICON:
        if (dataSource.activa === false) {
          return 'alert-yellow';
        }
        return '';
        break;
      case this.constants.PSDOMICI:
        if (dataSource.activo === false) {
          return 'alert-yellow';
        }
        return '';
        break;
      case this.constants.PSCTABAN:
        if (dataSource.activa === false) {
          return 'alert-yellow';
        }
        return '';
        break;
      case this.constants.EMMOVIMI:
        if (dataSource.cancelado === true) {
          return 'alert-danger';
        } else if (dataSource.detallesCancelado != null && dataSource.atencionCancelado == 0) {
          return 'alert-warning';
        }
        return '';
        break;
      case this.constants.RFFACTUR:
        if (dataSource.cancelada === true) {
          return 'alert-danger';
        } else if (dataSource.detallesCancelado != null && dataSource.atencionCancelado == 0) {
          return 'alert-warning';
        }
        return '';
        break;
      case this.constants.CTCONPER:
        if (dataSource.activo === false) {
          return 'alert-yellow';
        }
        return '';
        break;
      case this.constants.INSEGURO:
      case this.constants.INSEGURO_PAGOS:
        if (column == 'vigenciaPoliza') {
          if (dataSource.vigenciaPoliza === 'Vigente') {
            return 'alert-success';
          } else {
            return 'alert-danger';
          }
        }

        if (column == 'tenenciaPagada') {
          if (dataSource.tenenciaPagada === 'Pagada') {
            return 'alert-success';
          } else {
            return 'alert-danger';
          }
        }

        if (dataSource.inactivo == true) {
          return 'alert-danger';
        }

        return '';
        break;

      case this.constants.LILICENC:
        if (dataSource.activo === false) {
          return 'alert-yellow';
        }
        return '';
        break;

      case this.constants.PVPROVEE:
        if (dataSource.activo === false) {
          return 'alert-yellow';
        }
        return '';
        break;

      case this.constants.PVCTABAN:
        if (dataSource.activa === false) {
          return 'alert-yellow';
        }
        return '';
        break;

      case this.constants.PVCONTAC:
        if (dataSource.activo === false) {
          return 'alert-yellow';
        }
        return '';
        break;

      case this.constants.INPATINM:
        if (dataSource.activo === false) {
          return 'alert-danger';
        } else if (dataSource.vendido === true) {
          return 'alert-success';
        }
        return '';
        break;

      case this.constants.CTCONDIC:
        if (dataSource.idestatu == 2) {
          return 'alert-yellow';
        }
        return '';
        break;

      case this.constants.CTCONTRA:
        if (dataSource.idestatu == 2) {
          return 'alert-yellow';
        }
        return '';
        break;

      case this.constants.RQGENRAL:
        if (column == 'estatus') {
          if (dataSource.idestatu == 1 || dataSource.idestatu == 2) {
            return 'alert-yellow';
          } else if (dataSource.idestatu >= 3 && dataSource.idestatu <= 5) {
            return 'alert-secondary';
          } else if (dataSource.idestatu == 6) {
            return 'alert-success';
          } else if (dataSource.idestatu == 99) {
            return 'alert-danger';
          }
          return '';
        }
        break;

      case this.constants.CTCONFAC:
        if (new Date(dataSource.fechaVencimiento) < new Date() || dataSource.idestatu == 2) {
          return 'alert-yellow';
        } else if (new Date(dataSource.fechaVencimiento) >= new Date() || dataSource.idestatu == 1) {
          return 'alert-success';
        }

        break;

      case this.constants.CPFACTUR:
        if (dataSource.cancelada === true) {
          return 'alert-danger';
        }
        return '';
        break;

      case this.constants.CPMOVIMI:
        if (dataSource.idpagest === 7) {
          return 'alert-danger';
        }

        if (dataSource.anticipo === true && dataSource.idpagest === 3) {
          return 'alert-warning';
        }
        return '';
        break;

      case this.constants.PSCTACON:
        if (dataSource.activa === false) {
          return 'alert-yellow';
        }
        return '';
        break;

      case this.constants.CFDIS:
        if (dataSource.estado_cfdi === 'CANCELADO') {
          return 'alert-danger';
        }
        return '';
        break;

      case this.constants.CGGASTOS:

        if (column === 'estatus') {
          switch (dataSource.idestatu) {
            case 1:
              return 'alert-secondary';
              break;
            case 2:
              return 'alert-warning';
              break;
            case 4:
              return 'alert-info';
              break;
            case 6:
              return 'alert-success';
              break;
          }
        }
        return '';
        break;

      case this.constants.ANTIGUEDAD_SALDO:
        if (dataSource.mov === 2) {
          return 'alert-info';
        }
        break;

      default:
        return '';
        break;
    }
  }

  setDisplayColumn(tabla: string, dataSource: any, column: any, isDocumentacion: boolean): boolean {
    switch (tabla) {
      case this.constants.RFFACTUR:
        if (dataSource.uuid === '' && column === this.constants.EDITAR) {
          return true;
        } else if (dataSource.cancelada == true && column === this.constants.EMAIL) {
          return false;
        } else if (dataSource.uuid !== '' && (column === this.constants.VISUALIZAR || column === this.constants.XML || column === this.constants.PDF || column === this.constants.EMAIL || column === this.constants.VALIDAR_CFDI)) {
          return true;
        } else if (dataSource.enviada === true && column === this.constants.NOTIFICADO) {
          return true;
        } else if (dataSource.uuid !== '' && dataSource.cancelada == 0 && dataSource.parcialidad == 0 && column === this.constants.CANCELAR_CFDI) {
          return true;
        } else if (dataSource.saldoPendiente === 0 && column === this.constants.PAGADO) {
          return true;
        } else if (column === this.constants.HISTORIAL_PAGOS && (dataSource.parcialidad > 0 || dataSource.notasCredito > 0)) {
          return true;
        } else if (column === this.constants.NOTAS) {
          return true;
        } else if (column === this.constants.NOTA_CREDITO && dataSource.notasCredito > 0) {
          return true;
        }
        return false;
        break;
      case this.constants.EMMOVIMI:
        if (dataSource.uuid === '' && (column === this.constants.VISUALIZAR || column === this.constants.EDITAR)) {
          return true;
        } else if (dataSource.uuid !== '' && dataSource.cancelado === false && (column === this.constants.CANCELAR_CFDI || column === this.constants.VISUALIZAR || column === this.constants.XML || column === this.constants.PDF || column === this.constants.EMAIL || column === this.constants.VALIDAR_CFDI)) {
          return true;
        } else if (dataSource.enviado === true && dataSource.cancelado === false && column === this.constants.NOTIFICADO) {
          return true;
        } else if (dataSource.uuid !== '' && dataSource.cancelado === true && (column === this.constants.XML || column === this.constants.PDF || column === this.constants.VISUALIZAR || column === this.constants.VALIDAR_CFDI)) {
          return true;
        } else if (column === this.constants.NOTAS) {
          return true;
        }
        break;
      case this.constants.INPATRIM:
        if (dataSource.desarrolloMobiliario === false && column === this.constants.INMUEBLES) {
          return false;
        } else if (column === this.constants.PROPIETARIOS) {
          return false;
        } else if (dataSource.vendido === false && column === this.constants.VENDIDO) {
          return false;
        } else if (dataSource.fusion === false && column === this.constants.FUSION) {
          return false;
        } else if (dataSource.subdivision === false && column === this.constants.SUBDIVISION) {
          return false;
        } else {
          return true;
        }
        break;
      case this.constants.PREPAGOS:
        if (dataSource.idestatu === 4 && column === this.constants.EDITAR) {
          return false;
        } else if (dataSource.idestatu === 1 && column === this.constants.EMAIL) {
          return false;
        } else if (dataSource.notificado === false && column === this.constants.NOTIFICADO) {
          return false;
        } else {
          return true;
        }
        break;
      case this.constants.RQGENRAL:
        if (dataSource.idestatu === 1 && (column === this.constants.EDITAR || column === this.constants.EMAIL)) {
          return true;
        } else if (dataSource.idestatu === 99 && column === this.constants.EDITAR) {
          return false;
        } else if (dataSource.idestatu !== 1 && column === this.constants.VISUALIZAR) {
          return true;
        } else if (dataSource.tipoAdjunto !== undefined && column === this.constants.ELIMINAR) {
          return true;
        } else if (column === this.constants.UPLOAD_FACTURA && dataSource.idestatu !== 99 && dataSource.idestatu !== 1) {
          return true;
        } else if (column === this.constants.DOCUMENTOS) {
          return true;
        } else if (column === this.constants.VISUALIZAR && isDocumentacion) {
          return true;
        } else if (column === this.constants.ELIMINAR_DOCUMENTACION) {
          return false;
        } else if (dataSource.idestatu !== 1 && (column === this.constants.PDF || column === this.constants.ODC)) {
          return true;
        }

        break;

      case this.constants.CPFACTUR:
        if (column === this.constants.ELIMINAR && dataSource.idusuariValida !== 0) {
          return false;
        } else if ((column === this.constants.VALIDAR || column === this.constants.CANCELAR) && (dataSource.idusuariValida !== 0 || dataSource.cancelada !== false)) {
          return false;
        } else if (column === this.constants.REVISADO && dataSource.idusuariValida === 0) {
          return false;
        } else if (column === this.constants.REVISADO && dataSource.cancelada === true) {
          return false;
        } else if (column === this.constants.PAGADO && dataSource.saldoPendiente !== 0) {
          return false;
        } else if (column === this.constants.REQUISICION && dataSource.idgenral == 0) {
          return false;
        } else if (column === this.constants.XML && dataSource.uuid == '') {
          return false;
        } else {
          return true;
        }
        break;

      case this.constants.CPMOVIMI:
        if ((dataSource.idpagest === 6 || dataSource.idpagest === 7) && column === this.constants.EDITAR) {
          return false;
        } else if (column === this.constants.VISUALIZAR && dataSource.idpagest === 7) {
          return false;
        } else if (column === this.constants.ELIMINAR_DOCUMENTACION) {
          return false;
        } else if ((dataSource.idpagest === 6 || dataSource.idpagest === 7) && column === this.constants.RELOJ) {
          return false;
        } else if (dataSource.idpagest !== 6 && column === this.constants.PAGADO) {
          return false;
        } else if (column === this.constants.EMAIL && dataSource.cargadoComprobantePago == 0) {
          return false;
        } else if (column === this.constants.NOTIFICADO && dataSource.enviado == 0) {
          return false;
        } else if (column === this.constants.CANCELAR && (dataSource.idpagest === 6 || dataSource.idpagest === 7)) {
          return false;
        } else if (column === this.constants.NOTIFICADO_ANTICIPO && dataSource.notificadoAnticipo == 0) {
          return false;
        } else if (column === this.constants.CHECK && (dataSource.idpagest === 6 || dataSource.idpagest === 7 || dataSource.anticipo === true || dataSource.adjuntos > 0)) {
          return false;
        } else {
          return true;
        }
        break;

      case this.constants.CGGASDET:
        if (column === this.constants.DOCUMENTOS && (dataSource.idgasdet === null || dataSource.idgasdet === 0)) {
          return false;
        } else if (column === this.constants.ELIMINAR_DOCUMENTACION && dataSource.idestatu > 1) {
          return false;
        }
        return true;
        break;

      case this.constants.CGGASTOS:
        if ((column === this.constants.PDF || column === this.constants.DESCARGAR_ADJUNTOS) && (dataSource.idestatu == 1)) {
          return false;
        } else if (column === this.constants.RELOJ && (dataSource.idestatu === 6 || dataSource.idestatu === 1)) {
          return false;
        }
        return true;
        break;

      case this.constants.HISTORIAL_PAGOS:
        if (column === this.constants.PDF && dataSource.folioComplemento === 0) {
          return false;
        }
        return true;
        break;

      case this.constants.INPATINM:
        if (column === this.constants.VENDIDO && dataSource.vendido !== true) {
          return false
        }
        return true;
        break;

      case this.constants.ANTIGUEDAD_SALDO:
        if (column === this.constants.DETALLES && dataSource.mov === 2) {
          return false;
        } else if (column === this.constants.HISTORIAL_PAGOS && dataSource.parcialidad === 0) {
          return false;
        }
        return true;
        break;

      case this.constants.ESTADO_CUENTA_CXC:
        if (column === this.constants.DETALLES && dataSource.idSecundario === 0 && (dataSource.documento == 0 || dataSource.documento === '')) {
          return false;
        } else if (column === this.constants.DETALLES && dataSource.idSecundario !== 0 && (dataSource.documento == 0 || dataSource.documento === '')) {
          return false;
        }
        return true;
        break;

      case this.constants.INSEGURO:
        if (column === this.constants.PAGOS_AMORTIZABLES && dataSource.idarrend == 0) {
          return false;
        }
        return true;
        break;

      default:
        return true;
        break;
    }

  }

  isGranted(tabla: string, column: any, isDocumentacion: boolean): boolean {

    if (tabla === this.constants.GLTCD) {
      switch (column) {
        case this.constants.ELIMINAR:
          return this.permissionManagerService.isGranted(this.Control.TIPO_DE_CAMBIO_ELIMINAR);
          break;
        default:
          return false;
          break;
      }
    }

    if (tabla === this.constants.INPATRIM) {
      if (isDocumentacion === false) {
        switch (column) {
          case this.constants.EDITAR:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_EDITAR_PATRIMONIO);
            break;
          case this.constants.VISUALIZAR:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_VISUALIZAR_PATRIMONIO);
            break;
          case this.constants.DOCUMENTOS:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_DOCUMENTOS_PATRIMONIO);
            break;
          case this.constants.INMUEBLES:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_INMUEBLES);
            break;
          case this.constants.PROPIETARIOS:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_VISUALIZAR_RELACION_PROPIETARIOS);
            break;
          default:
            return true;
            break;
        }
      } else if (isDocumentacion === true) {
        switch (column) {
          case this.constants.AGREGAR:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_AGREGAR_DOCUMENTO_PATRIMONIO);
            break;
          case this.constants.VISUALIZAR:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_VISUALIZAR_DOCUMENTO_PATRIMONIO);
            break;
          case this.constants.ELIMINAR_DOCUMENTACION:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_ELIMINAR_DOCUMENTO_PATRIMONIO);
            break;
          default:
            return true;
            break;
        }
      }
    }


    if (tabla === this.constants.INPATINM) {
      if (isDocumentacion === false) {
        switch (column) {
          case this.constants.EDITAR:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_EDITAR_INMUEBLE);
            break;
          case this.constants.VISUALIZAR:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_VISUALIZAR_INMUEBLES);
            break;
          case this.constants.DOCUMENTOS:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_DOCUMENTOS_INMUEBLES);
            break;
          case this.constants.CONDICIONES:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_CONDICIONES_CONTRATOS);
            break;
          default:
            return true;  // FALTA ESTABLECER PERMISOS DE CONTRATOS
            break;

        }
      } else if (isDocumentacion === true) {
        switch (column) {
          case this.constants.AGREGAR:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_AGREGAR_DOCUMENTO_INMUEBLE);
            break;
          case this.constants.VISUALIZAR:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_VISUALIZAR_DOCUMENTO_INMUEBLE);
            break;
          case this.constants.ELIMINAR_DOCUMENTACION:
            return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_ELIMINAR_DOCUMENTO_INMUEBLE);
            break;
          default:
            return false;
            break;
        }
      }
    }


    if (tabla === this.constants.INPATPRO) {
      switch (column) {
        case this.constants.ELIMINAR:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_ELIMINAR_RELACION_PROPIETARIOS);
          break;
        default:
          return false;
          break;
      }
    }


    if (tabla === this.constants.CTCONDIC) {
      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_EDITAR_CONDICIONES);
          break;
        case this.constants.CONTRATOS:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_CONTRATOS_PRORROGAS);
          break;
        default:
          return true;
          break;
      }
    }

    if (tabla === this.constants.CTCONPER) {
      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_ARRENDADORES_EDITAR);
          break;
        case this.constants.DOCUMENTOS:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_ARRENDADORES_DOCUMENTOS);
          break;
        default:
          return true;
          break;
      }
    }


    if (tabla === this.constants.CTCONTRA) {
      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_EDITAR_CONTRATOS);
          break;
        case this.constants.CONVENIOS:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_CONVENIOS);
          break;
        case this.constants.FACTURACION_CONDICIONES:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_CONDICIONES_FACTURACION);
          break;
        case this.constants.FACTURACION_CONDICIONES:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_CONDICIONES_FACTURACION);
          break;
        case this.constants.DOCUMENTOS:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_CONTRATOS_DOCUMENTOS);
          break;
        case this.constants.ELIMINAR_DOCUMENTACION:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_DOCUMENTOS_CONTRATOS_ELIMINAR);
          break;
        default:
          return true;
          break;
      }
    }


    if (tabla === this.constants.CTCONVEN) {
      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_EDITAR_CONVENIO);
          break;
        case this.constants.DOCUMENTOS:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_DOCUMENTOS_CONVENIO);
          break;
        case this.constants.ELIMINAR_DOCUMENTACION:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_DOCUMENTOS_CONVENIO_ELIMINAR);
          break;
        default:
          return true;
          break;
      }
    }

    if (tabla === this.constants.CTCONFAC) {
      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.PATRIMONIOS_EDITAR_CONDICIONES_FACTURACION);
          break;
        default:
          return true;
          break;
      }
    }

    if (tabla === this.constants.EMMOVIMI) {
      switch (column) {
        case this.constants.VISUALIZAR:
          return this.permissionManagerService.isGranted(this.Control.PAGOS_VISUALIZAR_PAGO);
          break;
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.PAGOS_EDITAR_PAGO);
          break;
        case this.constants.CANCELAR_CFDI:
          return this.permissionManagerService.isGranted(this.Control.PAGOS_CANCELAR_CFDI);
          break;
        case this.constants.EMAIL:
          return this.permissionManagerService.isGranted(this.Control.PAGOS_ENVIAR_PAGO);
          break;
        case this.constants.XML:
        case this.constants.PDF:
        case this.constants.NOTIFICADO:
        case this.constants.VALIDAR_CFDI:
        case this.constants.NOTAS:
          return true;
          break;
        default:
          return false;
          break;
      }
    }

    if (tabla === this.constants.RFFACTUR) {
      switch (column) {
        case this.constants.VISUALIZAR:
          return this.permissionManagerService.isGranted(this.Control.FACTURACION_VISUALIZAR_FACTURA);
          break;
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.FACTURACION_EDITAR_FACTURA);
          break;
        case this.constants.EMAIL:
          return this.permissionManagerService.isGranted(this.Control.FACTURACION_ENVIAR_FACTURA);
          break;
        case this.constants.CANCELAR_CFDI:
          return this.permissionManagerService.isGranted(this.Control.CANCELAR_CFDI);
          break;
        case this.constants.XML:
        case this.constants.PDF:
        case this.constants.NOTIFICADO:
        case this.constants.VALIDAR_CFDI:
        case this.constants.PAGADO:
        case this.constants.NOTAS:
        case this.constants.HISTORIAL_PAGOS:
        case this.constants.NOTA_CREDITO:
          return true;
          break;
        default:
          return false;
          break;
      }
    }

    if (tabla === this.constants.PSPERSON) {

      if (isDocumentacion === false) {
        switch (column) {
          case this.constants.EDITAR:
            return this.permissionManagerService.isGranted(this.Control.CLIENTES_EDITAR_CLIENTE);
            break;
          case this.constants.VISUALIZAR:
            return this.permissionManagerService.isGranted(this.Control.CLIENTES_VISUALIZAR_CLIENTE);
            break;
          case this.constants.DOMICILIOS:
            return this.permissionManagerService.isGranted(this.Control.CLIENTES_DOMICILIOS);
            break;
          case this.constants.CONTACTOS:
            return this.permissionManagerService.isGranted(this.Control.CLIENTES_CONTACTOS);
            break;
          case this.constants.DOCUMENTOS:
            return this.permissionManagerService.isGranted(this.Control.CLIENTES_DOCUMENTOS);
            break;
          case this.constants.CUENTAS_BANCARIAS:
            return this.permissionManagerService.isGranted(this.Control.CLIENTES_CUENTAS);
            break;
          case this.constants.TERCEROS:
            return this.permissionManagerService.isGranted(this.Control.ADMINISTRACION_TERCEROS);
            break;
          case this.constants.CUENTAS_CONTABLES:
            return this.permissionManagerService.isGranted(this.Control.CUENTAS_CONTABLES);
            break;
          case this.constants.INFORMACION_GENERAL:
            return this.permissionManagerService.isGranted(this.Control.INFORMACION_GENERAL);
            break;
          case this.constants.PPE:
            return true;
            break;
          default:
            return false;
            break;
        }
      } else if (isDocumentacion === true) {
        switch (column) {
          case this.constants.AGREGAR:
            return this.permissionManagerService.isGranted(this.Control.CLIENTES_DOCUMENTOS_AGREGAR_DOCUMENTO);
            break;
          case this.constants.VISUALIZAR:
            return this.permissionManagerService.isGranted(this.Control.CLIENTES_DOCUMENTOS_VISUALIZAR_DOCUMENTO);
            break;
          case this.constants.ELIMINAR_DOCUMENTACION:
            return this.permissionManagerService.isGranted(this.Control.CLIENTES_DOCUMENTOS_ELIMINAR_DOCUMENTO);
            break;
          default:
            return false;
            break;
        }
      }
    }


    if (tabla === this.constants.PSPERSON_PROPIETARIO) {

      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.PROPIETARIOS_EDITAR_PROPIETARIO);
          break;
        case this.constants.VISUALIZAR:
          return this.permissionManagerService.isGranted(this.Control.PROPIETARIOS_VISUALIZAR_PROPIETARIO);
          break;
        case this.constants.DOMICILIOS:
          return this.permissionManagerService.isGranted(this.Control.PROPIETARIOS_DOMICILIOS);
          break;
        case this.constants.CONTACTOS:
          return this.permissionManagerService.isGranted(this.Control.PROPIETARIOS_CONTACTOS);
          break;
        case this.constants.DOCUMENTOS:
          return this.permissionManagerService.isGranted(this.Control.PROPIETARIOS_DOCUMENTOS);
          break;
        case this.constants.CUENTAS_BANCARIAS:
          return this.permissionManagerService.isGranted(this.Control.PROPIETARIOS_CUENTAS);
          break;
        case this.constants.CLIENTES:
          return this.permissionManagerService.isGranted(this.Control.PROPIETARIOS_RELACION_CLIENTE);
          break;
        case this.constants.CUENTAS_CONTABILIDAD:
          return this.permissionManagerService.isGranted(this.Control.PROPIETARIOS_CUENTAS_CONTABILIDAD);
          break
        case this.constants.TERCEROS:
          return this.permissionManagerService.isGranted(this.Control.ADMINISTRACION_TERCEROS);
          break;
        case this.constants.CUENTAS_CONTABLES:
          return this.permissionManagerService.isGranted(this.Control.CUENTAS_CONTABLES);
          break;
        case this.constants.INFORMACION_GENERAL:
          return this.permissionManagerService.isGranted(this.Control.INFORMACION_GENERAL);
          break;
        case this.constants.PPE:
          return true;
          break;
        default:
          return false;
          break;
      }

    }


    if (tabla === this.constants.INSEGURO || tabla === this.constants.INSEGURO_PAGOS) {

      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.SEGUROS_AGREGAR_EDITAR_POLIZA);
          break;
        case this.constants.PAGOS:
          return this.permissionManagerService.isGranted(this.Control.SEGUROS_PAGOS_POLIZAS);
          break;
      }

      if (isDocumentacion === true) {

        switch (column) {
          case this.constants.ELIMINAR_DOCUMENTACION:
            if (tabla === this.constants.INSEGURO) {
              return this.permissionManagerService.isGranted(this.Control.SEGUROS_ELIMINAR_DOCUMENTOS_POLIZA);
            } else {
              return this.permissionManagerService.isGranted(this.Control.SEGUROS_ELIMINAR_DOCUMENTOS_PAGOS);

            }
            break;
          case this.constants.AGREGAR:
            if (tabla === this.constants.INSEGURO) {
              return this.permissionManagerService.isGranted(this.Control.SEGUROS_AGREGAR_DOCUMENTO_POLIZA);
            } else {
              return this.permissionManagerService.isGranted(this.Control.SEGUROS_AGREGAR_DOCUMENTO_PAGOS);

            }
            break;
        }

      }
    }


    if (tabla === this.constants.PVPROVEE) {
      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.PROVEEDORES_EDITAR_PROVEEDOR);
          break;
        case this.constants.VISUALIZAR:
          return this.permissionManagerService.isGranted(this.Control.PROVEEDORES_VISUALIZAR_PROVEEDOR);
          break;
        case this.constants.CUENTAS_BANCARIAS:
          return this.permissionManagerService.isGranted(this.Control.PROVEEDORES_CUENTAS_BANCARIAS);
          break;
        case this.constants.CONTACTOS:
          return this.permissionManagerService.isGranted(this.Control.PROVEEDORES_CONTACTOS);
          break;
        case this.constants.CUENTAS_CONTABLES:
          return this.permissionManagerService.isGranted(this.Control.PROVEEDORES_CUENTAS_CONTABLES);
          break;
      }
    }

    if (tabla === this.constants.PVCONTAC) {
      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.PROVEEDORES_EDITAR_CONTACTO);
          break;
      }
    }

    if (tabla === this.constants.PVCTABAN) {
      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.PROVEEDORES_EDITAR_CUENTA_BANCARIA);
          break;
      }
    }

    if (tabla === this.constants.CPFACTUR) {
      switch (column) {
        case this.constants.CANCELAR:
        case this.constants.VALIDAR:
          return this.permissionManagerService.isGranted(this.Control.CXP_FACTURACION_REVISAR_FACTURAS);
          break;
      }
    }

    if (tabla === this.constants.PSTERCER) {
      switch (column) {
        case this.constants.ELIMINAR:
          return this.permissionManagerService.isGranted(this.Control.ELIMINAR_TERCERO);
          break;
      }
    }


    if (tabla === this.constants.CPMOVIMI) {
      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.CXP_PAGOS_EDITAR_PAGO);
          break;

        case this.constants.VISUALIZAR:
          return this.permissionManagerService.isGranted(this.Control.CXP_PAGOS_VISUALIZAR_PAGO);
          break;
        case this.constants.DOCUMENTOS:
          return this.permissionManagerService.isGranted(this.Control.CXP_PAGOS_DOCUMENTACION);
          break;
        case this.constants.EMAIL:
          return this.permissionManagerService.isGranted(this.Control.CXP_PAGOS_ENVIAR_PAGO);
          break;
        case this.constants.CANCELAR:
          return this.permissionManagerService.isGranted(this.Control.CXP_PAGOS_CANCELAR_PAGO);
          break;
      }
    }


    if (tabla === this.constants.LEACUSES) {
      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.ACUSES_EDITAR_ACUSE);
          break;
      }

      if (isDocumentacion === true) {

        switch (column) {
          case this.constants.ELIMINAR_DOCUMENTACION:
            return this.permissionManagerService.isGranted(this.Control.ACUSES_ELIMINAR_DOCUMENTOS);
            break;
          case this.constants.AGREGAR:
            return this.permissionManagerService.isGranted(this.Control.ACUSES_AGREGAR_DOCUMENTOS);
            break;
        }

      }
    }

    if (tabla === this.constants.PSINFGEN) {
      switch (column) {
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.INFORMACION_GENERAL_EDITAR);
          break;
        case this.constants.DOCUMENTOS:
          return this.permissionManagerService.isGranted(this.Control.INFORMACION_GENERAL_DOCUMENTOS);
          break;
        case this.constants.ELIMINAR_DOCUMENTACION:
          return this.permissionManagerService.isGranted(this.Control.INFORMACION_GENERAL_ELIMINAR_DOCUMENTOS);
          break;
      }
    }

    if (tabla === this.constants.PREPAGOS) {
      switch (column) {
        case this.constants.SOLICITUD:
          return this.permissionManagerService.isGranted(this.Control.PREDIALES_SOLICITUD);
          break;
        case this.constants.EMAIL:
          return this.permissionManagerService.isGranted(this.Control.PREDIALES_ENVIAR_COMPROBANTE);
          break;
        case this.constants.EDITAR:
          return this.permissionManagerService.isGranted(this.Control.PREDIALES_EDITAR_SOLICITUD);
          break;
        case this.constants.DOCUMENTOS:
          return this.permissionManagerService.isGranted(this.Control.PREDIALES_DOCUMENTOS);
          break;
        case this.constants.ELIMINAR_DOCUMENTACION:
          return this.permissionManagerService.isGranted(this.Control.PREDIALES_ELIMINAR_DOCUMENTO);
          break;
        default:
          return true;
          break;
      }
    }


    return true;

  }


  displayCurrency(tabla: string, dataSource: any, column: any): boolean {

    switch (tabla) {
      case this.constants.ESTADO_CUENTA_CXC:
        if (dataSource.debe > 0 && column === 'debe') {
          return true;
        }

        if (dataSource.haber > 0 && column === 'haber') {
          return true;
        }

        if (column === 'saldo') {
          return true;
        }

        break;

      case this.constants.ANTIGUEDAD_SALDO:

        if (dataSource.saldoSinVencer > 0 && column === 'saldoSinVencer') {
          return true;
        }

        if (dataSource.saldo1a30 > 0 && column === 'saldo1a30') {
          return true;
        }

        if (dataSource.saldo31a60 > 0 && column === 'saldo31a60') {
          return true;
        }

        if (dataSource.saldoMayor61 > 0 && column === 'saldoMayor61') {
          return true;
        }

        if (column === 'saldo') {
          return true;
        }

        if (dataSource.saldoSinConversion !== 0 && column === 'saldoSinConversion') {
          return true;
        }


        break;

      default:
        return true;
        break;
    }

  }

}
